import { DownloadService } from '@/data/services/download.service';
import Vue from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { VNode } from 'vue/types/umd';
import { createCDNUrl } from 'yellowfin-ui-lib';
import container from './services';

Vue.directive('numericOnly', {
	bind(el: HTMLElement, _binding: DirectiveBinding, vnode: VNode) {
		(vnode as any).$yfhandler = (_event: Event) => {
			let regex = /^[0-9]*$/;
			const input = el as HTMLInputElement;
			if (!regex.test(input.value)) {
				input.value = input.value ? input.value.slice(0, -1) : '';
				const ev = new Event('input', {
					'bubbles': true,
					'cancelable': true
				});
				input.dispatchEvent(ev);
			}
		}
		el.addEventListener('keyup', (vnode as any).$yfhandler)
	},
	unbind(el: HTMLElement,
		_binding: DirectiveBinding,
		vnode: VNode) {
		el.removeEventListener('keyup', (vnode as any).$yfhandler)
	}
})

Vue.directive('asyncimg', {
	bind(el: HTMLElement) {
		doAsyncimg(el)
	},
	update(el: HTMLElement, _binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) {
		const data = JSON.stringify(vnode.data?.attrs);
		const oldData = JSON.stringify(oldVnode.data?.attrs);
		if (data !== oldData) {
			doAsyncimg(el)
		}
	}
})

Vue.directive('asyncbg', {
	bind(el: HTMLElement) {
		doAsyncbg(el)
	},
	update(el: HTMLElement, _binding: DirectiveBinding, vnode: VNode, oldVnode: VNode) {
		const data = JSON.stringify(vnode.data?.attrs);
		const oldData = JSON.stringify(oldVnode.data?.attrs);
		if (data !== oldData) {
			doAsyncimg(el)
		}
	}
})

const doAsyncimg = function (el: HTMLElement) {
	const downloadService: DownloadService = container.get('DownloadService');

	const placeholder = el.dataset.placeholder;
	const size = el.dataset.size;
	const opaque = el.dataset.opaque;
	const cdn = el.dataset.cdn;
	const base = el.dataset.base;
	const folder = el.dataset.folder;
	const id = el.dataset.id
	const cdntype = el.dataset.cdntype

	const field = el.dataset.field || 'src';

	const imgEl = el as any;
	if (placeholder) {
		imgEl[field] = placeholder;
	}

	if (opaque) {
		if (cdn) {
			const cdnurl = createCDNUrl(cdn, base!, folder!, +id!, opaque, size!, cdntype);
			if (cdnurl) {
				imgEl[field] = cdnurl;
			}
		} else {
			if (!size) {
				downloadService.download(opaque).then(result => {
					imgEl[field] = URL.createObjectURL(result);
				});
			} else {
				downloadService.downloadThumb(opaque, size).then(result => {
					imgEl[field] = URL.createObjectURL(result);
				});
			}
		}
	}
}

const doAsyncbg = function (el: HTMLElement) {
	const downloadService: DownloadService = container.get('DownloadService');

	const placeholder = el.dataset.placeholder;
	const size = el.dataset.size;
	const opaque = el.dataset.opaque;
	const cdn = el.dataset.cdn;
	const base = el.dataset.base;
	const folder = el.dataset.folder;
	const id = el.dataset.id
	const cdntype = el.dataset.cdntype

	const divEl = el as HTMLDivElement;
	if (placeholder) divEl.style.backgroundImage = `url(${placeholder})`;

	if (opaque) {
		if (cdn) {
			const cdnurl = createCDNUrl(cdn, base!, folder!, +id!, opaque, size!, cdntype);
			if (cdnurl) {
				divEl.style.backgroundImage = `url(${cdnurl})`;
			}
		} else {
			if (!size) {
				downloadService.download(opaque).then(result => {
					divEl.style.backgroundImage = `url(${URL.createObjectURL(result)})`;
				});
			} else {
				downloadService.downloadThumb(opaque, size).then(result => {
					divEl.style.backgroundImage = `url(${URL.createObjectURL(result)})`;
				});
			}
		}
	}
}